var checkLocale = function() {
  return window?.Shopify?.locale ?? "de";
};


document.addEventListener("DOMContentLoaded", function() {
/*
  let userIconLoginButton = document.getElementsByClassName('header__icon header__icon--account');
  if (userIconLoginButton.length > 0) {
    if (checkLocale() == 'fr') {
      userIconLoginButton[0].href = 'https://www.tomtasty.ch/fr/a/loop_subscriptions/customer/';  
    } else if (checkLocale() == 'en') {
      userIconLoginButton[0].href = 'https://www.tomtasty.ch/en/a/loop_subscriptions/customer/';  
    } else {
      userIconLoginButton[0].href = 'https://www.tomtasty.ch/a/loop_subscriptions/customer/';
    }
  }
*/

  function getNextFridayAtEleven() {
    const today = new Date();
    const dayOfWeek = today.getDay(); // Wochentag als Zahl (0-6, wobei 0 Sonntag ist)
    let daysToAdd = 5 - dayOfWeek; // Tage bis zum nächsten Freitag

    // Wenn heute Freitag ist und es ist bereits nach 11 Uhr, oder wenn heute nicht Freitag ist, 
    // füge die notwendigen Tage hinzu, um den nächsten Freitag zu erreichen
    if (daysToAdd < 0 || (daysToAdd === 0 && today.getHours() >= 11)) {
      daysToAdd += 7;
    }
    const nextFriday = new Date(today.getFullYear(), today.getMonth(), today.getDate() + daysToAdd);
    nextFriday.setHours(11, 0, 0, 0); // Setze die Zeit explizit auf 11 Uhr morgens

    return nextFriday;
  }

  function getNextWednesdayAfterFriday() {
    const nextFriday = getNextFridayAtEleven();
    // Addiere 5 Tage zum Freitag, um den nächsten Mittwoch zu erreichen
    return new Date(nextFriday.getFullYear(), nextFriday.getMonth(), nextFriday.getDate() + 5);
  }
  
  const nextFridayAtEleven = getNextFridayAtEleven();
  const nextWednesdayAfterFriday = getNextWednesdayAfterFriday();
  const announcementBarMessage = document.querySelector('.announcement-bar__message span');
  let announcementBarMessageTextPart1 = 'Bestelle bis Freitag ';
  let announcementBarMessageTextPart2 = ' für eine Lieferung am Mittwoch ';
  let announcementBarMessageTextPart3 = '.';
  let languageRegion = 'de-CH';
  
  if (checkLocale() == 'fr') {
    languageRegion = 'fr-CH';
    announcementBarMessageTextPart1 = 'Commande avant vendredi ';
    announcementBarMessageTextPart2 = ' pour une livraison le mercredi ';
    announcementBarMessageTextPart3 = '.';
  } else if (checkLocale() == 'en') {
    languageRegion = 'en-US';
    announcementBarMessageTextPart1 = 'Order by Friday ';
    announcementBarMessageTextPart2 = ' for delivery on Wednesday ';
    announcementBarMessageTextPart3 = '.';
  }

  /* --- auskommentieren bei manuellem Datum --- */
  announcementBarMessage.innerHTML = announcementBarMessageTextPart1 + nextFridayAtEleven.toLocaleString(
    languageRegion, {
      year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', hour12: false 
    })
  + announcementBarMessageTextPart2 + '<span id="nextDeliveryDate">' + nextWednesdayAfterFriday.toLocaleString(
    languageRegion, { 
      year: 'numeric', month: '2-digit', day: '2-digit', hour12: false 
    }) + '</span>' + announcementBarMessageTextPart3;
    /* --- /auskommentieren bei manuellem Datum --- */
  
});